jQuery(function($){

  var element = $('#seemore'),
      pageUrl   = element.attr('data-pageurl'),
      pageTitle = element.attr('data-pagetitle'),
      posttype  = element.attr('data-posttype'),
      category  = element.attr('data-category'),
      slug      = element.attr('data-slug'),
      taxonomy  = element.attr('data-taxonomy'),
      template  = element.attr('data-template'),
      notin     = element.attr('data-notin'),
      loaderPrevious = $('.jc-loader-previous .jc-loader'),
      loaderFollow = $('.jc-loader-follow .jc-loader'),
      button  = $('.jc-load-more'),
      lastScroll = 0,
      isLoading = 0,
      nextPage = element.attr('data-nextpage'),
      prevPage = element.attr('data-prevpage');

  jQuery(document).ready(function () {

    loaderPrevious.addClass('d-none');
    loaderFollow.addClass('d-none');
    head_height = jQuery("#header").height();
    window.scrollTo(0, head_height);
  });

  $(window).scroll(function(){

    var scrollPos = jQuery(window).scrollTop();
    if (scrollPos >= 0.9*(jQuery(document).height() -jQuery('footer').height() - jQuery(window).height())) {
      if (isLoading==0) loadFollowing();
    }
    if (scrollPos <= 0.8 * jQuery("#header").height()) {
      if (isLoading==0) loadPrevious();
    }

    if (Math.abs(scrollPos - lastScroll)>jQuery(window).height()*0.1) {
      lastScroll = scrollPos;
      jQuery(".scrollpage").each(function(index) {
        if (mostlyVisible(this)) {
          var dataUrl = jQuery(this).attr("data-url");
          var dataPage = jQuery(this).attr("data-page");
          updateTitle(dataPage);
          history.replaceState(null, null, ( dataUrl != "" ? dataUrl : location.pathname) );
          return(false);
        }
      });
    }

  });



  function mostlyVisible(element) {

    var scrollPos = jQuery(window).scrollTop();
    var window_height = jQuery(window).height();
    var el_top = jQuery(element).offset().top;
    var el_height = jQuery(element).height();
    var el_bottom = el_top + el_height;
    return ((el_bottom - el_height*0.25 > scrollPos) &&
            (el_top < (scrollPos+0.5*window_height)));
  }

  function loadFollowing() {

    if ( nextPage != "" ) {

      isLoading = 1;
      loaderFollow.removeClass('d-none');

      jQuery.ajax({
        url: ajaxHandler.url,
        type: 'POST',
        data: {
          action: 'jc_ajax_get_posts_scroll',
          load: 'follow',
          page: nextPage,
          posttype : posttype,
          category: category,
          slug: slug,
          taxonomy: taxonomy,
          template: template,
          notin: notin
        },
        success: function(response) {
          loaderFollow.addClass('d-none');
          showFollowing(response);
          pushPageView();
          isLoading = 0;
        },
        error: function(data) {
        }
      });

      function showFollowing(response) {
        jQuery('div.scrollpage:last').after(response.data.layout);
        nextPage = response.data.nextPage;
      }

    }
  };

  function pushPageView(){

    dataLayer.push({
      'event':'VirtualPageview',
      'virtualPageURL': pageUrl,
      'virtualPageTitle': pageTitle
    });

    dataLayerEstadao.push({
      'event':'forcePvCheckout',
      'page': pageUrl
    });

    gtag('event', 'VirtualPageview', {
      'virtualPageURL': pageUrl,
      'virtualPageTitle': pageTitle
    });

  }

  function updateTitle( page ){
    jQuery('title').text(jQuery('meta[property="og:title"]').attr('content') + ( page > 1 ? ' - Página ' + page : '' ));
  }

  function loadPrevious() {

    if ( prevPage !== "" ) {

      isLoading = 1;
      loaderPrevious.removeClass('d-none');

      jQuery.ajax({
        url: ajaxHandler.url,
        type: 'POST',
        data: {
          action: 'jc_ajax_get_posts_scroll',
          load: 'previous',
          page: prevPage,
          posttype : posttype,
          category: category,
          slug: slug,
          taxonomy: taxonomy,
          template: template,
          notin: notin
        },
        success: function(response) {
          loaderPrevious.addClass('d-none');
          showPrevious(response);
          pushPageView();
          isLoading = 0;
        },
        error: function(data) {
        }
      });

      function showPrevious(response) {
        jQuery('div.scrollpage:first').before(response.data.layout);
        item_height = jQuery("div.scrollpage:first").height();
        window.scrollTo(0, jQuery(window).scrollTop()+item_height);
        prevPage = response.data.prevPage;
      }

    }
  };



});
